/* eslint-disable react/forbid-elements */
import { DpButtonForm } from '@/components/blocks/DpLibrary/DpButtonForm';
import { DpDpValeForm } from '@/components/blocks/DpLibrary/DpDpValeForm';
import { combineSX } from '@/utils/combineSX';
import { Box, Stack, SxProps } from '@mui/material';
import React, { useState } from 'react';
import { DpDrawer } from '@/components/blocks/DpDrawer';

export const DpButtonModalForm = ({
	labelbutton,
	title,
	formfields,
	framesx,
}: {
	labelbutton?: any;
	title?: string;
	formfields?: any;
	framesx?: SxProps;
}) => {
	const [openModal, setOpenModal] = useState<boolean>(false);

	const handleSubmitClick = () => {
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	return (
		<Stack
			sx={combineSX([
				{ height: '100%', marginTop: '10px', width: '100%', paddingTop: '20px', paddingX: '20px' },
				...(Array.isArray(framesx) ? framesx : [framesx]),
			])}
		>
			{labelbutton ? <DpButtonForm label={labelbutton} onClick={handleSubmitClick} /> : null}

			{title && formfields ? (
				<DpDrawer title={title} open={openModal} onClose={handleCloseModal}>
					<Box sx={{ marginTop: '10px' }}>
						<DpDpValeForm formfields={formfields} />
					</Box>
				</DpDrawer>
			) : null}
		</Stack>
	);
};
